import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate} from 'react-router-dom'
import { addProductAsync, resetProductAddStatus, selectProductAddStatus } from '../../products/ProductSlice'
import { Button, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography, useMediaQuery, useTheme, FormControlLabel, Checkbox } from '@mui/material'
import { useForm } from "react-hook-form"
import { selectBrands } from '../../brands/BrandSlice'
import { selectCategories } from '../../categories/CategoriesSlice'
import { toast } from 'react-toastify'

export const AddProduct = () => {

    const {register,handleSubmit,reset} = useForm()

    const [thumbnailFile, setThumbnailFile] = useState(null)
    const [imageFiles, setImageFiles] = useState([null, null, null, null])
    const [videoFile,setVideoFile]=useState(null)
    const [isRecommended, setIsRecommended] = useState(false)
    const [isTopSeller, setIsTopSeller] = useState(false)

    const dispatch=useDispatch()
    const brands=useSelector(selectBrands)
    const categories=useSelector(selectCategories)
    const productAddStatus=useSelector(selectProductAddStatus)
    const navigate=useNavigate()
    const theme=useTheme()
    const is1100=useMediaQuery(theme.breakpoints.down(1100))
    const is480=useMediaQuery(theme.breakpoints.down(480))

    useEffect(()=>{
        if(productAddStatus==='fullfilled'){
            reset()
            setThumbnailFile(null)
            setImageFiles([null,null,null,null])
            setVideoFile(null)
            toast.success("New product added")
            navigate("/admin/dashboard")
        }
        else if(productAddStatus==='rejected'){
            toast.error("Error adding product, please try again later")
        }
    },[productAddStatus, navigate, reset])

    useEffect(()=>{
        return ()=>{
            dispatch(resetProductAddStatus())
        }
    },[dispatch])

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
        })

    const handleAddProduct = async (data) => {
        if (!thumbnailFile) {
            toast.error("Thumbnail is required")
            return
        }
        const existingImages = imageFiles.filter(Boolean)
        if (existingImages.length === 0) {
            toast.error("At least one product image is required")
            return
        }

        try {
            const thumbBase64 = await fileToBase64(thumbnailFile)
            const imagesBase64 = await Promise.all(existingImages.map(fileToBase64))
            const videoBase64 = videoFile ? await fileToBase64(videoFile) : null

            const newProduct = {
                ...data,
                thumbnail: thumbBase64,
                images: imagesBase64,
                video: videoBase64,
                isRecommended,
                isTopSeller
            }

            dispatch(addProductAsync(newProduct))
        } catch (err) {
            toast.error("Failed to read images, please try again")
            console.error(err)
        }
    }

    
  return (
    <Stack p={'0 16px'} justifyContent={'center'} alignItems={'center'} flexDirection={'row'} >
        

        <Stack width={is1100?"100%":"60rem"} rowGap={4} mt={is480?4:6} mb={6} component={'form'} noValidate onSubmit={handleSubmit(handleAddProduct)}> 
            
            {/* feild area */}
            <Stack rowGap={3}>
                <Stack>
                    <Typography variant='h6' fontWeight={400} gutterBottom>Title</Typography>
                    <TextField {...register("title",{required:'Title is required'})}/>
                </Stack> 

                <Stack flexDirection={'row'} >

                    <FormControl fullWidth>
                        <InputLabel id="brand-selection">Brand</InputLabel>
                        <Select {...register("brand",{required:"Brand is required"})} labelId="brand-selection" label="Brand">
                            
                            {
                                brands.map((brand)=>(
                                    <MenuItem value={brand._id}>{brand.name}</MenuItem>
                                ))
                            }

                        </Select>
                    </FormControl>


                    <FormControl fullWidth>
                        <InputLabel id="category-selection">Category</InputLabel>
                        <Select {...register("category",{required:"category is required"})} labelId="category-selection" label="Category">
                            
                            {
                                categories.map((category)=>(
                                    <MenuItem value={category._id}>{category.name}</MenuItem>
                                ))
                            }

                        </Select>
                    </FormControl>

                </Stack>


                <Stack>
                    <Typography variant='h6' fontWeight={400}  gutterBottom>Description</Typography>
                    <TextField multiline rows={4} {...register("description",{required:"Description is required"})}/>
                </Stack>

                <Stack flexDirection={'row'}>
                    <Stack flex={1}>
                        <Typography variant='h6' fontWeight={400}  gutterBottom>Price</Typography>
                        <TextField type='number' {...register("price",{required:"Price is required"})}/>
                    </Stack>
                    <Stack flex={1}>
                        <Typography variant='h6' fontWeight={400}  gutterBottom>Discount {is480?"%":"Percentage"}</Typography>
                        <TextField type='number' {...register("discountPercentage",{required:"discount percentage is required"})}/>
                    </Stack>
                </Stack>

                <Stack flexDirection={'row'}>
                    <Stack flex={1}>
                        <Typography variant='h6' fontWeight={400}  gutterBottom>Delivery Charge</Typography>
                        <TextField type='number' {...register("deliveryCharge",{required:"Delivery charge is required"})}/>
                    </Stack>
                    <Stack flex={1}>
                        <Typography variant='h6' fontWeight={400}  gutterBottom>Online Pay Discount %</Typography>
                        <TextField type='number' {...register("onlinePaymentDiscount",{required:"Online payment discount is required"})}/>
                    </Stack>
                </Stack>

                <Stack>
                    <Typography variant='h6'  fontWeight={400} gutterBottom>Stock Quantity</Typography>
                    <TextField type='number' {...register("stockQuantity",{required:"Stock Quantity is required"})}/>
                </Stack>
                <Stack>
                    <Typography variant='h6'  fontWeight={400} gutterBottom>Thumbnail</Typography>
                    <Button variant="outlined" component="label">
                        Select Thumbnail
                        <input hidden type="file" accept="image/*" onChange={(e)=>setThumbnailFile(e.target.files[0])} />
                    </Button>
                    <Typography variant='body2' color='text.secondary'>
                        {thumbnailFile ? thumbnailFile.name : "No file chosen"}
                    </Typography>
                </Stack>

                <Stack>
                    <Typography variant='h6'  fontWeight={400} gutterBottom>Product Images</Typography>

                    <Stack rowGap={2}>
                        {[0,1,2,3].map((idx)=>(
                            <Stack key={idx} rowGap={0.5}>
                                <Button variant="outlined" component="label">
                                    Select Image {idx+1}
                                    <input
                                        hidden
                                        type="file"
                                        accept="image/*"
                                        onChange={(e)=>{
                                            const files=[...imageFiles]
                                            files[idx]=e.target.files[0]||null
                                            setImageFiles(files)
                                        }}
                                    />
                                </Button>
                                <Typography variant='body2' color='text.secondary'>
                                    {imageFiles[idx]?.name || "No file chosen"}
                                </Typography>
                            </Stack>
                        ))}
    
                    </Stack>

                </Stack>

                <Stack>
                    <Typography variant='h6'  fontWeight={400} gutterBottom>Product Video (optional)</Typography>
                    <Button variant="outlined" component="label">
                        Select Video
                        <input hidden type="file" accept="video/*" onChange={(e)=>setVideoFile(e.target.files[0]||null)} />
                    </Button>
                    <Typography variant='body2' color='text.secondary'>
                        {videoFile ? videoFile.name : "No video selected"}
                    </Typography>
                </Stack>

                <Stack>
                    <Typography variant='h6'  fontWeight={400} gutterBottom>Product Features</Typography>
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={isRecommended} 
                                onChange={(e) => setIsRecommended(e.target.checked)}
                            />
                        }
                        label="⭐ Mark as Recommended"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox 
                                checked={isTopSeller} 
                                onChange={(e) => setIsTopSeller(e.target.checked)}
                            />
                        }
                        label="🔥 Mark as Top Seller"
                    />
                </Stack>

            </Stack>

            {/* action area */}
            <Stack flexDirection={'row'} alignSelf={'flex-end'} columnGap={is480?1:2}>
                <Button size={is480?'medium':'large'} variant='contained' type='submit'>Add Product</Button>
                <Button size={is480?'medium':'large'} variant='outlined' color='error' component={Link} to={'/admin/dashboard'}>Cancel</Button>
            </Stack>

        </Stack>

    </Stack>
  )
}
